import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { bulkCreateActionsWithContacts, createActionWithContacts, createAnonymousAction, deleteAction, getAction, queryActions, updateAction } from '@wix/ambassador-ai-scheduling-assistant-v1-action/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { ActionClientBase } from './ActionClientBase';
export class ActionClient extends HttpBaseClient(ActionClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getActionImpl", getAction);
    _defineProperty(this, "queryActionsImpl", queryActions);
    _defineProperty(this, "createActionWithContactsImpl", createActionWithContacts);
    _defineProperty(this, "bulkCreateActionsWithContactsImpl", bulkCreateActionsWithContacts);
    _defineProperty(this, "updateActionImpl", updateAction);
    _defineProperty(this, "deleteActionImpl", deleteAction);
    _defineProperty(this, "createAnonymousActionImpl", createAnonymousAction);
  }
}
//# sourceMappingURL=ActionClientHttp.js.map